import { BrowserRouter } from "react-router-dom";
//
import Routes from "./routes";
import "./App.css";
import { AuthProvider } from "./hooks/auth";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
